import { Toast } from '@revenuemarket/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCorporateCardBusinessRegNo } from '~apis/corporate-card/updateCorporateCardConnection';
import { useCompanyId } from '~hooks/useCompanyId';

import { USE_BUSINESS_REGISTRATION_NUMBERS_QUERY } from './useBusinessRegistrationNumbers';
import { USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY } from './useCorporateCardConnections';
import { USE_GET_CORPORATE_CARD_LIST_QUERY } from './useGetCorporateCardList';

/**
 * 법인카드 연결 사업자번호 수정 훅
 */
export function useUpdateCorporateCardBusinessRegNo() {
  const queryClient = useQueryClient();
  const { companyId } = useCompanyId();

  return useMutation({
    mutationFn: ({
      connectionId,
      businessRegNo,
    }: {
      connectionId: number;
      businessRegNo: string;
    }) => updateCorporateCardBusinessRegNo(companyId, connectionId, businessRegNo),
    onSuccess: () => {
      Toast.success('사업자등록번호가 수정되었습니다.');
      queryClient.invalidateQueries({
        queryKey: USE_GET_CORPORATE_CARD_CONNECTIONS_QUERY.default(companyId),
      });
      queryClient.invalidateQueries({
        queryKey: USE_GET_CORPORATE_CARD_LIST_QUERY.default(companyId),
      });
      queryClient.invalidateQueries({
        queryKey: USE_BUSINESS_REGISTRATION_NUMBERS_QUERY.default(companyId),
      });
    },
    onError: () => {
      Toast.error('사업자등록번호 수정에 실패했습니다.');
    },
  });
}
